import { create } from "zustand";

export interface OverrideEntry {
  balance: string;           // Formatted (e.g., "0" or "414.5")
  lastReadAt: number;        // Timestamp
  chainId: number;
  tokenAddress: string;      // Lowercased, or "" for native
  symbol: string;
  decimals: number;          // Needed for refreshAllOverrides
}

interface OverrideStore {
  overrides: Record<string, OverrideEntry>;   // Key: `${chainId}-${tokenAddress.toLowerCase()}`
  setOverride: (key: string, entry: OverrideEntry) => void;
  getOverride: (chainId: number, tokenAddress: string) => OverrideEntry | undefined;
  clearAll: () => void;
  clearForToken: (chainId: number, tokenAddress: string) => void;
}

const makeKey = (chainId: number, tokenAddress: string): string =>
  `${chainId}-${(tokenAddress || "").toLowerCase()}`;

export const useOnChainBalanceOverrides = create<OverrideStore>((set, get) => ({
  overrides: {},

  setOverride: (key: string, entry: OverrideEntry) =>
    set((state) => ({
      overrides: {
        ...state.overrides,
        [key]: entry,
      },
    })),

  getOverride: (chainId: number, tokenAddress: string) => {
    const key = makeKey(chainId, tokenAddress);
    return get().overrides[key];
  },

  clearAll: () => set({ overrides: {} }),

  clearForToken: (chainId: number, tokenAddress: string) =>
    set((state) => {
      const key = makeKey(chainId, tokenAddress);
      const { [key]: _, ...rest } = state.overrides;
      return { overrides: rest };
    }),
}));
